// extracted by mini-css-extract-plugin
export default {"wrap":"nO-z","fullWidth":"oO-z","hideOnDesktop":"pO-z","content":"qO-z","hasOpenedNav":"rO-z","crumbsList":"sO-z","dropdownsWrap":"tO-z"};